import { UseCustomAxios } from "../../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../../util/Utils";

export function UseHomeMagazine() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
    };

    setter(errorState);

    if (errorState.title) {
      enqueueSnackbar("لطفا اطلاعات مجله را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetHomeMagazines = (categoryID, callback) => {
    MyAxios.get(`Admin_HomeMagazine`, {
      headers: {
        AID: categoryID,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const addMagazine = (state, icon, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (icon) {
      data.append("Image", icon);
    }
    MyAxios.post(`Admin_HomeMagazine`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("مجله با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const updateMagazine = (state, icon, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (icon) {
      data.append("Image", icon);
    }
    MyAxios.put(`Admin_HomeMagazine`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("مجله با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    validate,
    GetHomeMagazines,
    addMagazine,
    updateMagazine,
  };
}
